/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useEffect } from 'react'
import { onAuthStateChange, logoutUser } from '../services/auth'
import { getTutorProfile } from '../services/firestore'
import { capitalizeName } from '../utils/formatters'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tutorProfile, setTutorProfile] = useState(null)

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (firebaseUser) => {
      if (firebaseUser) {
        // Cargar perfil del tutor desde Firestore
        const profileResult = await getTutorProfile(firebaseUser.uid)
        if (profileResult.success) {
          if (profileResult.data?.isDisabled === true) {
            await logoutUser()
            alert('Tu cuenta ha sido deshabilitada por un administrador.')
            setUser(null)
            setTutorProfile(null)
            setLoading(false)
            return
          }
          setUser(firebaseUser)
          setTutorProfile(profileResult.data)
        } else {
          setUser(firebaseUser)
          // Si no existe perfil, crear uno básico
          setTutorProfile({
            id: firebaseUser.uid,
            email: firebaseUser.email,
            fullName: capitalizeName(firebaseUser.displayName) || '',
            bio: '',
            career: '',
            year: '',
            phone: '',
            location: '',
            skills: [],
            achievements: [],
            avatar: ''
          })
        }
      } else {
        setUser(null)
        setTutorProfile(null)
      }
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  const value = {
    user,
    tutorProfile,
    loading,
    setTutorProfile
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}



